module.exports = __webpack_public_path__ + "d77c174050ab39cc180c1b2b5f9d50f2.svg";